import menu from './menu';
import notifications from './notifications';

const facilities = window.env.FACILITIES;

export default {
    rootPath: window.env.APP_URL,
    currentConnection: window.env.FACILITY,
    connections: function() {
        let connections = _.map(facilities, (item) => {
            return { id: item.code, name: item.name, link: 'http://' + item.domain + '/admin/'}
        });
        if (_.get(this.user, 'role.facility')) {
            return _.filter(connections, (conn) => conn.id == this.user.role.facility);
        }

        return connections;
    },
    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/dashboard',
        endpoints: {
            '^/pages': {
                params: { filter: 'parent_id:$null' },
            },
            '^/panels': {
                params: { filter: 'content_id:$null' },
            },
            '^/document_categories': {
                params: { filter: 'parent_id:$null' },
            },
            '^/events': {
                params: { filter: 'id(d):$current' }
            },
            '^/campaigns': {
                params: { filter: 'sent:0' }
            },
            '^/compendiums': {
                params: { sort: 'name:asc' }
            },
            '^/enquiries': {
                params: { sort: 'created_at:desc' }
            },
            '^/subscribers': {
                params: { sort: 'created_at:desc' }
            },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            csv: ['csv'],
        }
    },
    menu,
    notifications,
}
